/**
 * Standard couple dropdown label:
 * coupleId – LastName, hisFirstName & herFirstName (hisEmail & herEmail)
 *
 * Notes:
 * - We fall back to `id` when `coupleId` is not provided by an API payload.
 * - When one of the first names / emails is missing, we display what we have.
 */

export interface CoupleLabelInput {
  primaryKey?: string | number | null;
  coupleId?: string | number | null;
  value?: string | number | null;
  hisFirstName?: string | null;
  herFirstName?: string | null;
  hisLastName?: string | null;
  herLastName?: string | null;
  hisEmail?: string | null;
  herEmail?: string | null;
  [key: string]: unknown;
}

export function formatCoupleOptionLabel(
  couple: CoupleLabelInput | null | undefined,
): string {
  if (!couple) return "";

  const rawId = couple.primaryKey ?? couple.coupleId ?? couple.value;
  const coupleId =
    rawId != null && String(rawId).trim() !== "" ? String(rawId).trim() : null;

  const hisFirst = (couple.hisFirstName || "").trim();
  const herFirst = (couple.herFirstName || "").trim();

  const lastName = (couple.hisLastName || couple.herLastName || "").trim();

  const nameCore =
    `${lastName}${lastName && (hisFirst || herFirst) ? ", " : ""}${hisFirst}${
      herFirst ? ` & ${herFirst}` : ""
    }`.trim();

  const emails = [couple.hisEmail, couple.herEmail]
    .map((e) => (e || "").trim())
    .filter(Boolean)
    .join(" & ");
  const emailPart = emails ? ` (${emails})` : "";

  const prefix = coupleId ? `${coupleId} \u2013 ` : "";

  return `${prefix}${nameCore}${emailPart}`.trim();
}
